import React from 'react';
import { DesktopNavigation } from '@core/ui/navigation';
import type { NavigationModuleBehavior } from '@core/ui/navigation';
import { zoocasaNavigationConfig } from 'tenants/zoocasa/config/navigation';
import { useLocationResolution } from 'hooks/use-location-resolution';
import { processNavigationItemsWithLocation } from 'utils/navigation-item-processor';

interface HeaderNavMenuProps {
  isCrawler: boolean;
}

const HeaderNavMenu = ({ isCrawler }: HeaderNavMenuProps) => {

  const resolvedLocation = useLocationResolution();

  const menuItemBehavior: NavigationModuleBehavior = {
    ...zoocasaNavigationConfig.module.behavior,
    expandAllSubmenus: isCrawler,
  };

  const navHeaderItems = processNavigationItemsWithLocation(
    zoocasaNavigationConfig.structure.header,
    resolvedLocation
  );

  return (
    <DesktopNavigation 
      items={navHeaderItems}
      behavior={menuItemBehavior}
      isCrawler={isCrawler}
    />
  );
};

export default HeaderNavMenu; 